export default {
  en: {
    pageTitles: {
      assessment: 'Assessment',
      assessmentWizard: 'Assessment wizard',
      assessmentOverview: 'Assessment overview',
      bizapproval: "{company}'s business approval",
      clients: 'Clients',
      dashboard: 'Dashboard',
      discussions: 'Discussions',
      zeusGraph: 'Network graph',
      policies: 'Policies',
      scopingQuestions: 'Scoping questions',
      clientReporting: {
        compliance: 'Compliance reporting',
        activity: 'Activity reporting',
        performance: 'Performance reporting',
        risk: 'Risk reporting',
      },
      settings: 'Settings',
      suppliers: 'Suppliers',
      wizard: 'Wizard',
    },
    systemUser: 'System user',
    deletedUser: 'Deleted user',
    deactivatedUser: '{name} (deactivated)',
    currentUser: '{name} (You)',
    justNow: 'just now',
    genericErrorTitle: 'An error has occurred',
    genericError: 'Try again or {contactSupport}',
    genericErrorContactSupport: 'contact support',
    learnMore: 'Learn more',
    moreInformation: 'More information: {text}',
    validation: {
      url: 'Enter a valid URL',
      confirmPassword: 'Passwords do not match',
      invalidPhone: 'Enter a valid phone number',
      leadModePermissions: 'Lead user must have client and supplier mode permission',
      invalidDomain: 'Enter a valid domain',
    },
    passwordRequirements:
      'Use at least eight characters, including an uppercase letter, a lowercase letter, a number, and one of these symbols: {symbols}',
    landlinePhoneWarning:
      'This looks like a landline. It cannot receive SMS codes, so you will need to use an authenticator app for two-factor authentication.',
    cta: {
      cancel: 'Cancel',
      close: 'Close',
      saveChanges: 'Save changes',
    },
    restrictions: {
      supplierRestrictionDescription:
        'You are only shown information relevant to your assigned suppliers.',
    },
    you: 'You',
  },
};
